import { Icon } from './index'

export const RightArrow: Icon = ({ variant = '', xs, disabled }) => (
	<svg
		className={disabled ? 'stroke-gray-400' : variant}
		width={xs ? '16' : '24'}
		height={xs ? '16' : '24'}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14.43 5.92999L20.5 12L14.43 18.07"
			strokeWidth="1.5"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M3.5 12H20.33"
			strokeWidth="1.5"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)
